import { isTablet } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { ReserveLogo, textLogo } from "src/assets/images/logo";
import { PATH_URL } from "src/interfaces";

interface PropsType {
  styles?: React.CSSProperties;
  isLink?: boolean;
}

const NafutelReserveLogo = ({ styles, isLink }: PropsType) => {
  const navigate = useNavigate();
  const onClick = () => {
    if (isLink) {
      navigate(PATH_URL.HOME);
    }
  };
  return (
    <div
      onClick={onClick}
      className="d-flex align-items-center"
      style={{ ...styles, cursor: isLink ? "pointer" : "auto" }}
    >
      <ReserveLogo
        width={isTablet ? 25 : undefined}
        height={isTablet ? 29 : undefined}
      />
      <div
        style={{
          marginTop: isTablet ? 7 : "20px",
          marginLeft: "10px",
        }}
      >
        <img
          src={textLogo}
          alt=""
          width={isTablet ? 64 : undefined}
          height={isTablet ? 16 : undefined}
        />
        <p
          style={{
            position: "relative",
            top: isTablet ? 0 : "-3px",
            fontSize: isTablet ? 10 : "17px",
            color: "#ffffff",
            marginLeft: "15px",
            marginBottom: isTablet ? 10 : undefined,
          }}
        >
          Reserve
        </p>
      </div>
    </div>
  );
};

export { NafutelReserveLogo };
